import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { lazy, Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Navbar from './Shared/Components/Scroll/Navbar/Navbar';
import Footer from './Shared/Components/Footer/Footer';
import Hero from './Shared/Components/Hero/Hero';
import Prouducts from './Shared/Components/Products/Prouducts';
import Landing from './Shared/Components/Landing/Landing';
import States from './Shared/Components/States/States';
import Experience from './Shared/Components/Experience/Experience';
import AboutUs from './Shared/Components/AboutUs/AboutUs';
import Services from './Shared/Components/Services/Services';
import LiveGallery from './Shared/Components/LiveGallery/LiveGallery';
import AppShowcase from './Shared/Components/AppShowcase/AppShowcase';
import AppFeatures from './Shared/Components/AppFeatures/AppFeatures';
import { Route, Routes, useLocation } from 'react-router-dom';
import RequireAuth from './Shared/Components/Auth/RequireAuth';

const Terms = lazy(() => import('./Shared/Routes/Terms'));
const Privacy = lazy(() => import('./Shared/Routes/Privacy'));
const FAQ = lazy(() => import('./Shared/Routes/FAQ'));
const ProductDetails = lazy(() => import('./Shared/Components/Products/ProductDetails/ProductDetails'));

const Login = lazy(() => import('./Shared/Components/Auth/Login/Login'));
const Register = lazy(() => import('./Shared/Components/Auth/Register/Register'));
const VerifyOtp = lazy(() => import('./Shared/Components/Auth/VerifyOtp/VerifyOtp'));
const ForgotPassword = lazy(() => import('./Shared/Components/Auth/ForgotPassword/ForgotPassword'));
const ResetPassword = lazy(() => import('./Shared/Components/Auth/ResetPassword/ResetPassword'));

const Account = lazy(() => import('./Shared/Components/Account/Account'));
const Cart = lazy(() => import('./Shared/Components/Cart/Cart'));
const Checkout = lazy(() => import('./Shared/Components/Checkout/Checkout'));
const PaymentResult = lazy(() => import('./Shared/Components/Payment/PaymentResult'));
const MyBooks = lazy(() => import('./Shared/Components/MyBooks/MyBooks'));
const BookReader = lazy(() => import('./Shared/Components/MyBooks/BookReader/BookReader'));
const Podcasts = lazy(() => import('./Shared/Components/Podcasts/Podcasts'));
const PodcastDetails = lazy(() => import('./Shared/Components/Podcasts/PodcastDetails/PodcastDetails'));
const Radio = lazy(() => import('./Shared/Components/Radio/Radio'));

function App() {

   const {i18n } = useTranslation();
   const location = useLocation();

  useEffect(() => {
    const isArabic = i18n.language === "ar";

    document.documentElement.lang = isArabic ? "ar" : "en";
    document.documentElement.dir = isArabic ? "rtl" : "ltr";

    document.body.classList.toggle("lang-ar", isArabic);
    document.body.classList.toggle("lang-en", !isArabic);

    if (location.pathname === "/") {
      document.title = isArabic
        ? "تكوين | كتب • بودكاست • راديو مباشر"
        : "Takween | Books • Podcasts • Live Radio";
    }
  }, [i18n.language, location.pathname]);

  return (
    <div className="App">
      <Navbar />

      <Suspense fallback={<div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}></div>}>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <AboutUs />
                <Services />
                <Prouducts />
                <Landing />
                <States />
                <Experience />
                <LiveGallery />
                <AppFeatures />
                <AppShowcase />
              </>
            }
          />

          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/products/:id" element={<ProductDetails />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route
            path="/account"
            element={
              <RequireAuth>
                <Account />
              </RequireAuth>
            }
          />
          <Route path="/cart" element={<Cart />} />
          <Route
            path="/checkout"
            element={
              <RequireAuth>
                <Checkout />
              </RequireAuth>
            }
          />
          <Route path="/payment/success" element={<PaymentResult status="success" />} />
          <Route path="/payment/fail" element={<PaymentResult status="fail" />} />
          <Route path="/payment/pending" element={<PaymentResult status="pending" />} />

          <Route
            path="/my-books"
            element={
              <RequireAuth>
                <MyBooks />
              </RequireAuth>
            }
          />
          <Route
            path="/my-books/:bookId/read"
            element={
              <RequireAuth>
                <BookReader />
              </RequireAuth>
            }
          />

          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/podcasts/:id" element={<PodcastDetails />} />
          <Route path="/radio" element={<Radio />} />
        </Routes>
      </Suspense>

      <Footer />
    </div>
  );
}

export default App;
